// TODO: deprecate
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { DateRangePicker, SingleDatePicker } from 'react-dates'
import { useDispatch, useSelector } from 'react-redux'
import { debounce } from 'lodash'
import moment from 'moment'

import {
  setDepartureDate,
  setReturnDate
} from '../../../../redux/ferryRouteSelections/actions'
import {
  selectDepartureDate,
  selectReturnDate
} from '../../../../redux/ferryRouteSelections/selectors'
import * as UserSelectionActions from '../../../../redux/userSelections/actions'
import FerryRoutesFormDateSelect from './FerryRoutesFormDateSelect'
import { selectLanguage } from '../../../../redux/session/selectors'

/**
  TODO(ebarrett):
    - Verify the types of the dates returned in the handlers (seems 
      to be a lot of moment conversion happening)
    - Generic date handlers should be passed in (don't use dispatch directly here)
*/

const FerryRoutesFormDateRangePicker = ({
  ferryLabels,
  returnDateOnly,
  startDate,
  disabled
}) => {
  const dispatch = useDispatch()
  const departureDate = useSelector(selectDepartureDate)
  const returnDate = useSelector(selectReturnDate)
  const language = useSelector(selectLanguage)
  const [focus, setFocus] = useState(null)
  // Setting or maintaining dates through renders & form changes
  useEffect(() => {
    if (departureDate && !returnDate) {
      const nextDate =
        startDate && moment(startDate).isAfter(moment(departureDate))
          ? moment(startDate).add(1, 'days')
          : moment(departureDate).add(1, 'days')
      dispatch(setReturnDate(nextDate)) // TODO: Deprecate
      dispatch(
        UserSelectionActions.setReturnSearchDate(nextDate.format('YYYY-MM-DD'))
      )
    }
  }, [dispatch, returnDate, departureDate, startDate])

  const [calendarSize, setCalendarSize] = useState(
    window.innerWidth > 1024 ? 'lg' : 'sm'
  )

  function checkNumberOfMonths() {
    const size = window.innerWidth > 1024 ? 'lg' : 'sm'

    if (calendarSize !== size) {
      setCalendarSize(size)
    }
  }

  const debounced = debounce(checkNumberOfMonths, 100)

  useEffect(() => {
    window.addEventListener('resize', debounced)

    return () => {
      debounced.cancel()
      window.removeEventListener('resize', debounced)
    }
  })

  useEffect(() => {
    if (!startDate || moment(startDate).isSameOrBefore(departureDate)) {
      return
    }
    handleOnDateChange({
      startDate: startDate,
      endDate: moment(startDate)
        .add(1, 'days')
        .format('YYYY-MM-DD')
    })
  })

  const handleOnDateChange = ({ startDate, endDate }) => {
    const newStartDate = moment(startDate)
    dispatch(setDepartureDate(newStartDate)) // TODO: Deprecate
    dispatch(
      UserSelectionActions.setDepartureSearchDate(
        newStartDate.format('YYYY-MM-DD')
      )
    )

    const newEndDate = moment(
      endDate ? endDate : moment(startDate).add(1, 'days')
    )
    dispatch(setReturnDate(newEndDate)) // TODO: Deprecate
    dispatch(
      UserSelectionActions.setReturnSearchDate(newEndDate.format('YYYY-MM-DD'))
    )
  }

  const handleReturnDateChange = date => {
    dispatch(setReturnDate(date)) // TODO: Deprecate
    dispatch(
      UserSelectionActions.setReturnSearchDate(
        moment(date).format('YYYY-MM-DD')
      )
    )
  }

  const toggleCustomDate = dateField => {
    const targetDatePicker = returnDateOnly
      ? 'one-way-return'
      : 'round-trip-' + dateField
    document.getElementById(targetDatePicker).focus()
  }

  let dateRangeMinimumNights
  if (process.env.REACT_APP_FLOW_CLIENT_ID === 'nfl') {
    dateRangeMinimumNights = 0
  } else {
    dateRangeMinimumNights = 1
  }

  return departureDate && returnDate ? (
    <div className="ferry-routes__form-date-range-picker">
      {returnDateOnly ? (
        <SingleDatePicker
          block={true}
          date={returnDate ? returnDate.locale(language) : returnDate}
          daySize={36}
          displayFormat="MMM D, YYYY"
          disabled={disabled}
          focused={focus}
          horizontalMargin={30}
          id="one-way-return"
          isOutsideRange={date =>
            date.isBefore(
              startDate && moment(startDate).isAfter(moment())
                ? moment(startDate)
                : moment(departureDate)
            ) || date.isAfter(moment().add(18, 'months'))
          }
          navNext={<i className="material-icons">east</i>}
          navPrev={<i className="material-icons">west</i>}
          noBorder={true}
          numberOfMonths={1}
          onDateChange={handleReturnDateChange}
          onFocusChange={() => {
            if (!focus) {
              const targetHeight = window.innerHeight + 400
              window.setTimeout(() => {
                window.scrollTo(0, targetHeight)
              }, 250)
            }

            setFocus(!focus)
          }}
          firstDayOfWeek={0}
          transitionDuration={0}
        />
      ) : (
        <DateRangePicker
          block={true}
          customArrowIcon={<span className="u-remove-element"></span>}
          customCloseIcon={<span className="u-remove-element"></span>}
          daySize={36}
          displayFormat={language === 'fr' ? 'DD MMM YYYY' : '"MMM D, YYYY"'}
          endDate={
            returnDate ? moment(returnDate).locale(language) : returnDate
          }
          disabled={disabled}
          endDateId="round-trip-return"
          focusedInput={focus}
          horizontalMargin={30}
          isOutsideRange={date =>
            date.isBefore(
              startDate && moment(startDate).isAfter(moment())
                ? moment(startDate)
                : moment(),
              'day'
            ) || date.isAfter(moment().add(18, 'months'))
          }
          minimumNights={dateRangeMinimumNights}
          navNext={<i className="material-icons">east</i>}
          navPrev={<i className="material-icons">west</i>}
          noBorder={true}
          numberOfMonths={calendarSize === 'lg' ? 2 : 1}
          onDatesChange={handleOnDateChange}
          onFocusChange={focus => {
            if (focus) {
              const targetHeight = window.innerHeight + 400
              window.setTimeout(() => {
                window.scrollTo(0, targetHeight)
              }, 250)
            }

            setFocus(focus)
          }}
          showClearDates={true}
          startDate={
            departureDate
              ? moment(departureDate).locale(language)
              : departureDate
          }
          startDateId="round-trip-departure"
          firstDayOfWeek={0}
          transitionDuration={0}
        />
      )}

      <div className="ferry-routes__form-date-range-picker-selects">
        {!returnDateOnly && (
          <FerryRoutesFormDateSelect
            activeDateValue={departureDate}
            containerClassNames="u-form__custom-select--half"
            dateField="departure"
            ferryLabels={ferryLabels}
            fieldLabel={ferryLabels.departureDate}
            toggleDateEvent={toggleCustomDate}
            disabled={disabled}
          />
        )}

        <FerryRoutesFormDateSelect
          activeDateValue={returnDate}
          containerClassNames="u-form__custom-select--half"
          dateField="return"
          ferryLabels={ferryLabels}
          fieldLabel={ferryLabels.returnDate}
          toggleDateEvent={toggleCustomDate}
          disabled={disabled}
        />
      </div>
    </div>
  ) : null
}

FerryRoutesFormDateRangePicker.propTypes = {
  ferryLabels: PropTypes.shape(),
  returnDateOnly: PropTypes.bool.isRequired,
  startDate: PropTypes.string,
  disabled: PropTypes.bool
}

export default FerryRoutesFormDateRangePicker
